import gql from 'graphql-tag';

export const createPass = gql`
  mutation getInvitePass($data: PassInviteInput) {
    getInvitePass(data: $data) {
      hash
    }
  }
`;

export const openGuestSmartLock = gql`
  mutation openGuestSmartLock($guestHash: String!) {
    openGuestSmartLock(guestHash: $guestHash)
  }
`;
